import { Modal, Button } from "react-bootstrap";
// import { Button, Modal } from "antd";
import React, { useEffect } from "react";
import trash from "../../Assets/Images/trash.png";

//css
import "./Modal.css";
import { CalendarOutlined, WarningOutlined } from "@ant-design/icons";
import { DatePicker, Select } from "antd";
import { Form } from "react-bootstrap";
import BtnDelete from "../Commons/Buttons/BtnDelete";
import BtnSave from "../Commons/Buttons/BtnSave";
import DateField from "../Commons/Forms/DateField";
import { getRole, getTomorrowDate, getUser } from "../Helpers/Utilities/Common";

const { Option } = Select;

function AppointmentModal(props) {
  const dateTomorrow = getTomorrowDate();
  const role = getRole();
  const userId = getUser();

  useEffect(() => {
   if(role !== "nurse"){
    props.setSelectedDoctor(userId)
   }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  // Handle submit with loading state
  const handleSubmit = () => {
    props.onConfirm();
  };

  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Body>
          <div className="row">
            <Form.Label className="form-title align-center">
              {props.title || `Reschedule`}
            </Form.Label>

            <div className="mt-2 mb-2 col-12 align-left">
              {props.patient || ""}
            </div>
          </div>
          {/*if user is admin/resident, no need to select doctor.*/}
          {role === "nurse" && (
            <>
              <div className="row mt-1">
                <span>Doctor</span>
                <Select
                  placeholder="Select Doctor"
                  onChange={props.setSelectedDoctor} // Directly update state
                  value={props.selectedDoctor} // Use selected doctor
                  allowClear
                  options={props.doctorsData}
                  optionFilterProp="label"
                  showSearch
                />
              </div>
            </>
          )}
          <div className="row mt-2">
            <DateField
              required
              className="mt-0"
              id="scheduled_on"
              name="scheduled_on"
              formLabel={`Date`}
              size={`sm`}
              min={dateTomorrow}
              value={props.defaultDate}
              onChange={(e) => props.setRescheduledDate(e.target.value)}
            />
          </div>

          <div className="row mt-4 right">
            <div className="col-6">
              <BtnDelete label={"Cancel"} size={"sm"} 
              onClick={() => {
                localStorage.setItem("openAppointmentModal", JSON.stringify(false));
                props.onHide(); 
              }}
              />
            </div>
            <div className="col-6">
              <BtnSave
                label={"Submit"}
                size={"sm"}
                isClicked={props.isClicked}
                onClick={handleSubmit}
                disabled={props.isClicked}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default AppointmentModal;
